import { useEffect, useState } from 'react'
import logo from '../../assets/logo.png'
import './NavBar.css'

export default function Navbar() {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const hero = document.querySelector('.hero')
        if (!hero) return

        const handleScroll = () => {
            setVisible(window.scrollY >= hero.offsetHeight)
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll()
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <nav className={`navbar ${visible ? 'navbar--visible' : ''}`}>
            <img
                src={logo}
                alt="Vedra"
                className="navbar-logo"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
            <ul className="navbar-links">
                <li><a href="#solutions">Solutions</a></li>
                <li><a href="#company">Company</a></li>
                <li><a href="#contact">Contact Us</a></li>
            </ul>
        </nav>
    )
}